import { render, staticRenderFns } from "./GeneralTable.vue?vue&type=template&id=230f83d6&scoped=true&lang=pug&"
import script from "./GeneralTable.vue?vue&type=script&lang=js&"
export * from "./GeneralTable.vue?vue&type=script&lang=js&"
import style0 from "./GeneralTable.vue?vue&type=style&index=0&id=230f83d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230f83d6",
  null
  
)

export default component.exports